// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__fAI_L","rs-skeleton-pulse":"Skeleton_rs-skeleton-pulse__yre2S"};